import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import type { QueueType } from "../../queue/QueueType.js";
import { readJsonQueueType } from "../../queue/QueueType.js";


export class PacketInRemovedFromQueue extends PacketIn {
    public queueType: QueueType | null = null;

    constructor() {
        super(InboundPacketType.REMOVED_FROM_QUEUE);
    }

    getQueueType(): QueueType {
        if (this.queueType === null)
            throw new Error("Packet has not been read yet");

        return this.queueType;
    }

    override readContents(
        _context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        this.queueType = readJsonQueueType(json);
    }
}
